import { AuthService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '@proxy/clients';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  standalone: false,
})
export class ConfirmEmailComponent implements OnInit {
  hasError = false;
  isSuccess = false;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    public router: Router,
    public authService: AuthService,

  ) { }

  ngOnInit() {
    if (this.authService.isAuthenticated) {
      this.router.navigate(['/account/login']);
      return;
    }

    const userId = this.route.snapshot.queryParamMap.get('userId');
    const token = this.route.snapshot.queryParamMap.get('token') ?? '';

    this.clientService.confirmEmail({ userId, token }).subscribe({
      next: () => {
        this.isSuccess = true;

        setTimeout(() => {
          this.router.navigate(['/account/login']);
        }, 3000);
      },
      error: () => {
        this.hasError = true;
      },
    });
  }
}
